import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useBusinessModelTypologiesStore = defineStore('business-model-typologies', {
  state: () => ({
    businessModelTypologies: [],
    activeBusinessModelTypologies: [],
  }),

  actions: {
    loadBusinessModelTypologies(params = {}) {
      this.businessModelTypologies = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      if (params.country?.length) {
        query.append('country', params.country.join(','));
      }

      if (params.city?.length) {
        query.append('city', params.city.join(','));
      }

      if (params.procurement_type?.length) {
        query.append('procurement_type', params.procurement_type.join(','));
      }

      if (params.business_model_typology?.length) {
        query.append('business_model_typology', params.business_model_typology.join(','));
      }

      if (params.city_population_range?.length) {
        query.append('city_population_range', params.city_population_range.join(','));
      }

      return apiFetch({
        path: `/wp-json/ebus/market/business-model-typologies?${query.toString()}`,
      }).then((data) => {
        this.businessModelTypologies = data;
        
        return data;
      }).catch((error) => {
        console.log('Error: ', error);
      });
    },

    toggleBusinessModelTypology(businessModelTypology) {
      const index = this.activeBusinessModelTypologies.indexOf(businessModelTypology);

      if (index === -1) {
        this.activeBusinessModelTypologies.push(businessModelTypology);
      } else {
        this.activeBusinessModelTypologies.splice(index, 1);
      }
    },

    resetActiveBusinessModelTypologies() {
      this.activeBusinessModelTypologies = [];
    },
  },
});
